import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-loader-white',
    templateUrl: 'loader-white.component.html',
    styleUrls: ['./loader-white.component.css']
})

export class WhiteLoaderComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }
}
